module.exports = {"idServerRedirectUri":"http://vmc.local-dev.com/"}


//////////////////
// WEBPACK FOOTER
// ./Client/app/common/constants/dev.json
// module id = 518
// module chunks = 0